import { render, staticRenderFns } from "./priceBgremoval.vue?vue&type=template&id=378d8504&scoped=true"
import script from "./priceBgremoval.vue?vue&type=script&lang=js"
export * from "./priceBgremoval.vue?vue&type=script&lang=js"
import style0 from "./priceBgremoval.vue?vue&type=style&index=0&id=378d8504&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378d8504",
  null
  
)

export default component.exports